/** @jsx jsx */
import { jsx } from "theme-ui"
import Menu from "../components/menu"

const directionLinks = [
  { name: "Tunezja 🇹🇳", link: "/oferty/tunezja" },
  { name: "Egipt 🇪🇬", link: "/oferty/egipt" },
  { name: "Grecja 🇬🇷", link: "/oferty/grecja" },
  { name: "Turcja 🇹🇷", link: "/oferty/turcja" },
  { name: "Hiszpania 🇪🇸", link: "/oferty/hiszpania" },
  { name: "Cypr 🇨🇾", link: "/oferty/cypr" },
  { name: "Bułgaria 🇧🇬", link: "/oferty/bulgaria" },
  { name: "Polska 🇵🇱", link: "/oferty/polska" },
]

const otherLinks = [
  // {
  //   name: "Wyjazdy na mecze ⚽︎",
  //   link: "https://wyjazdnamecz.pl",
  //   inNewTab: true,
  // },
  {
    name: "Parkingi przy lotnisku",
    link: "https://parkingiprzylotnisku.pl/",
    inNewTab: true,
  },
  { name: "RODO", link: "/rodo" },
  { name: "Polityka Prywatności", link: "/polityka-prywatnosci" },
  { name: "Regulamin", link: "/regulamin" },
  { name: "Kontakt", link: "/kontakt" },
]
export const navLinks = [
  { name: "Oferty", link: "/" },
  { name: "Last minute", link: "/oferty/last-minute" },
  // { name: "Last minute Tunezja", link: "/oferty/tunezja-last-minute" },
  { name: "All inclusive", link: "/oferty/all-inclusive" },

  {
    custom: true,
    component: () => <Menu links={directionLinks} title="Kierunki ⬇" />,
  },
  { name: "Blog", link: "/blog" },
  // { name: 'Egzotyka', link: '/egzotyka' },
  // { name: 'Lato 2023', link: '/lato2023' }, - nie da rady bo url sie nie stworzy, ale nie testowano
  // { name: 'Wycieczki objazdowe', link: '/wycieczki-objazdowe' },
  {
    custom: true,
    component: () => <Menu links={otherLinks} title="Inne" />,
  },
  // { custom: true, component: Tui },
]

export const CTA_TEXT = "Pokaż oferty"
